import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useMapSVGOverlayStyles = makeStyles(() => {
  return createStyles({
    outline: {
      outline: 'none',
      height: '100%',
      width: '100%',
      zIndex: 1,
      pointerEvents: 'none',
      position: 'absolute',
    },
    svg: {
      height: '100%',
      width: '100%',
      '& g': {
        pointerEvents: 'all',
      },
    },
  });
});

export default useMapSVGOverlayStyles;
